module.exports = __webpack_public_path__ + "img/Bireme64_ua.0405e796.webp";